interface ThinkingIndicatorProps {
  className?: string;
}

/**
 * ThinkingIndicator - Indicador de "pensando" com animação de 3 pontos
 */
export const ThinkingIndicator = ({ className = '' }: ThinkingIndicatorProps) => {
  return (
    <div className={`flex items-center gap-1 py-2 ${className}`}>
      <div
        className="w-2 h-2 bg-[#F4CC04] rounded-full animate-bounce"
        style={{ animationDelay: '0s', animationDuration: '1.4s' }}
      />
      <div
        className="w-2 h-2 bg-[#F4CC04] rounded-full animate-bounce"
        style={{ animationDelay: '0.2s', animationDuration: '1.4s' }}
      />
      <div
        className="w-2 h-2 bg-[#F4CC04] rounded-full animate-bounce"
        style={{ animationDelay: '0.4s', animationDuration: '1.4s' }}
      />
    </div>
  );
};
